export { default } from './EntryRevalidator';
export type { EntryRevalidatorProps } from './EntryRevalidator';
